import { render } from "./TwinSelect.vue?vue&type=template&id=4cacfb6f"
import script from "./TwinSelect.vue?vue&type=script&lang=js"
export * from "./TwinSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__